module.exports = __webpack_public_path__ + "static/media/shikara.8f88e3ac.png";